import React from 'react'
import styled, {css} from 'styled-components'
import {Styles, Combind} from '../styles'
import {Colors} from '../colors'

export const Span = styled.span`
    color: ${props => props.color || Colors.Black};
`

export default Span